import * as XLSX from "xlsx";

const createCompilationFile = (fileName: string, data: any) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Kooste");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default createCompilationFile;